export function getSearchHitElementId(objectId: string) {
  return `search-hit-${objectId}`;
}
